import { Card } from 'react-bootstrap';
import PropertyPicker from './components/PropertyPicker';
import { connect } from 'react-redux';
import BaseFeature from './BaseFeature';
import { STEP_DIM, STEP_DIM8 } from '../../../../../../utils/constantFeatures';
import PropertyDropdown from './components/PropertyDropdown';
import { getMinutes } from '../../../../../../utils/constantValues';
import DraggableAreaChart from './charts/DraggableAreaChart';
import { getErrorIssues } from '../../../../../../utils/validationSummary';
import { Trans } from 'react-i18next';

class StepDim extends BaseFeature {

    constructor(props) {
        super(props);

        this.state = {
        };

        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(propertyName, value) {
        // in case the propery is from another feature
        if (this.getCorrectPropertyName(propertyName) === STEP_DIM8.stepDimColor1
        || this.getCorrectPropertyName(propertyName) === STEP_DIM8.stepDimColor2
        || this.getCorrectPropertyName(propertyName) === STEP_DIM8.stepDimColor3  ) {
            let property = this.props.extraProperties[propertyName];
            property.value = value;
            this.props.handleChangeExtraProperties(property);
        } else {
            const v = value;
            this.props.handleChange(propertyName, v);
        }
    }

    render() {

        const nominalLevel = this.props.properties[STEP_DIM.nominalLevel];
        const stepDimLevel = this.props.properties[STEP_DIM.stepDimLevel];
        const switchOnFadeTime = this.props.properties[STEP_DIM.switchOnFadeTime];
        const startfadeTime = this.props.properties[STEP_DIM.startfadeTime];
        const holdTime = this.props.properties[STEP_DIM.holdTime];
        const endfadeTime = this.props.properties[STEP_DIM.endfadeTime];

        const dataChart = this.getDataChart(this.props.properties);

        const displayColors = this.props.driverFeatures.some(item => item.name === 'sd8');

        return (
            <div className="flex-column">
                <div className="flex-row">
                    <Card className={this.getClassName([nominalLevel, stepDimLevel])}>
                        <div className="card-header-feature">
                            <Trans i18nKey="Output_Levels" />
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            <PropertyPicker
                                property={nominalLevel}
                                inputPadding={'padding-none'}
                                title={<Trans i18nKey="Nominal_Level" />}
                                measureUnit={'%'}
                                min={nominalLevel.valueMeta.min}
                                max={nominalLevel.valueMeta.max}
                                step={1}
                                handleChange={this.handleChange} />
                            {displayColors
                                ?
                                <PropertyPicker
                                    property={this.props.extraProperties[STEP_DIM8.stepDimColor1]}
                                    inputPadding={'padding-none'}
                                    title={this.props.extraProperties[STEP_DIM8.stepDimColor1].info['displayName']}
                                    measureUnit={this.props.extraProperties[STEP_DIM8.stepDimColor1].info['unit']}
                                    min={this.props.extraProperties[STEP_DIM8.stepDimColor1].valueMeta['min']}
                                    max={this.props.extraProperties[STEP_DIM8.stepDimColor1].valueMeta['max']}
                                    step={1}
                                    handleChange={this.handleChange} />
                                :
                                null
                            }
                            <PropertyPicker
                                property={stepDimLevel}
                                inputPadding={'padding-none'}
                                title={<Trans i18nKey="SD_Level" />}
                                measureUnit={'%'}
                                min={stepDimLevel.valueMeta.min}
                                max={stepDimLevel.valueMeta.max}
                                step={1}
                                handleChange={this.handleChange} />
                            {displayColors
                                ?
                                <PropertyPicker
                                    property={this.props.extraProperties[STEP_DIM8.stepDimColor2]}
                                    inputPadding={'padding-none'}
                                    title={this.props.extraProperties[STEP_DIM8.stepDimColor2].info['displayName']}
                                    measureUnit={this.props.extraProperties[STEP_DIM8.stepDimColor2].info['unit']}
                                    min={this.props.extraProperties[STEP_DIM8.stepDimColor2].valueMeta['min']}
                                    max={this.props.extraProperties[STEP_DIM8.stepDimColor2].valueMeta['max']}
                                    step={1}
                                    handleChange={this.handleChange} />
                                :
                                null
                            }
                        </Card.Body>
                    </Card>

                    <Card className={this.getClassName([switchOnFadeTime])}>
                        <div className="card-header-feature">
                            <Trans i18nKey="Switch_On_Timing" />
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            <PropertyDropdown
                                property={switchOnFadeTime}
                                properties={switchOnFadeTime.valueMeta.availableValues.sort((a, b) => parseInt(a) - parseInt(b))}
                                propertyDisplayFunc={getMinutes}
                                title={switchOnFadeTime.info.displayName + ' [1]'}
                                measureUnit={'mm:ss'}
                                handleChange={this.handleChange} />
                            {displayColors
                                ?
                                <PropertyPicker
                                    property={this.props.extraProperties[STEP_DIM8.stepDimColor3]}
                                    inputPadding={'padding-none'}
                                    title={this.props.extraProperties[STEP_DIM8.stepDimColor3].info['displayName']}
                                    measureUnit={this.props.extraProperties[STEP_DIM8.stepDimColor3].info['unit']}
                                    min={this.props.extraProperties[STEP_DIM8.stepDimColor3].valueMeta['min']}
                                    max={this.props.extraProperties[STEP_DIM8.stepDimColor3].valueMeta['max']}
                                    step={1}
                                    handleChange={this.handleChange} />
                                :
                                null
                            }
                        </Card.Body>
                    </Card>

                    <Card className={this.getClassName([startfadeTime, holdTime, endfadeTime])}>
                        <div className="card-header-feature">
                            <Trans i18nKey="SD_Timing" />
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            <PropertyDropdown
                                property={startfadeTime}
                                properties={startfadeTime.valueMeta.availableValues.sort((a, b) => parseInt(a) - parseInt(b))}
                                propertyDisplayFunc={getMinutes}
                                title={startfadeTime.info.displayName + ' [2]'}
                                measureUnit={'mm:ss'}
                                handleChange={this.handleChange} />
                            <PropertyDropdown
                                property={holdTime}
                                properties={holdTime.valueMeta.availableValues.sort((a, b) => parseInt(a) - parseInt(b))}
                                propertyDisplayFunc={getMinutes}
                                title={holdTime.info.displayName + ' [3]'}
                                measureUnit={'mm:ss'}
                                handleChange={this.handleChange} />
                            <PropertyDropdown
                                property={endfadeTime}
                                properties={endfadeTime.valueMeta.availableValues.sort((a, b) => parseInt(a) - parseInt(b))}
                                propertyDisplayFunc={getMinutes}
                                title={endfadeTime.info.displayName + ' [4]'}
                                measureUnit={'mm:ss'}
                                handleChange={this.handleChange} />
                        </Card.Body>
                    </Card>
                </div>

                <div className="flex-row">
                    <Card className="card-feature-component" style={{ width: '100%' }}>
                        <div className="card-header-feature">
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            <DraggableAreaChart
                                containsErrors={getErrorIssues(this.props.issues, this.props.properties).length > 0}
                                id={"stepDim"}
                                properties={this.props.properties}
                                dataChart={dataChart}
                                x={{ 'title': 'Time' }}
                                y={{ 'title': 'Output Level (%)' }}
                                min={{ y: 0, x: 0 }}
                                max={{ y: 110, x: 1250 }}
                                tickValues={{ x: [], y: [] }}
                                xLabels={this.getXLabels(dataChart)}
                                yLabels={this.getYLabels(dataChart)}
                                sections={{ 0: "area-light", 1: "area-dark", 2: "area-light", 3: "area-dark", 4: "area-light", 5: "area-dark", 6: "area-light" }}
                                handleChange={this.handleChartChange} />
                        </Card.Body>
                    </Card>
                </div>

                <div className="flex-row">
                    <Card className="card-feature-component" style={{ width: '100%' }}>
                        <div className="card-header-feature">
                        </div>
                        <Card.Body className="card-body-feature" style={{ paddingTop: '0.75rem' }}>
                            <DraggableAreaChart
                                containsErrors={getErrorIssues(this.props.issues, this.props.properties).length > 0}
                                id={"sdSignal"}
                                type={"secondary"}
                                height={200}
                                properties={this.props.properties}
                                dataChart={this.getDataChartSD(this.props.properties)}
                                x={{ 'title': '' }}
                                y={{ 'title': 'SD active *)' }}
                                min={{ y: 0, x: 0 }}
                                max={{ y: 100, x: 1250 }}
                                tickValues={{ x: [], y: [] }}
                                xLabels={this.getXLabels(dataChart)}
                                handleChange={this.handleChartChange} />
                            <div>
                                {' *) Real signal may be reversed (according to operating mode)'}
                            </div>
                        </Card.Body>
                    </Card>
                </div>

            </div>
        );
    }

    getDataChart(properties) {
        const dataChart = [{}, {}, {}, {}, {}, {}, {}, {}, {}];

        dataChart[0] = {
            x: 0,
            y: 0,
            timeLabel: "startTime-0",
            section: 0
        }

        const switchOnFadeTimeIndex = properties[STEP_DIM.switchOnFadeTime].valueMeta.availableValues.indexOf(properties[STEP_DIM.switchOnFadeTime].value);
        dataChart[1] = {
            x: dataChart[0].x + (switchOnFadeTimeIndex > 0 ? (switchOnFadeTimeIndex * 11) : 0),
            y: +properties[STEP_DIM.nominalLevel].value,
            timeLabel: "switchOnFadeTime-1",
            section: 0
        }

        dataChart[2] = {
            x: dataChart[1].x + 70,
            y: +properties[STEP_DIM.nominalLevel].value,
            timeLabel: "dimStart-0",
            section: 1
        }

        const startfadeTimeIndex = properties[STEP_DIM.startfadeTime].valueMeta.availableValues.indexOf(properties[STEP_DIM.startfadeTime].value);
        dataChart[3] = {
            x: dataChart[2].x + (startfadeTimeIndex > 0 ? (startfadeTimeIndex * 12) : 0),
            y: +properties[STEP_DIM.stepDimLevel].value,
            timeLabel: "startfadeTime-2",
            section: 2
        }

        dataChart[4] = {
            x: dataChart[3].x + 70,
            y: +properties[STEP_DIM.stepDimLevel].value,
            timeLabel: "dimEnd-0",
            section: 3
        }

        const holdTimeIndex = properties[STEP_DIM.holdTime].valueMeta.availableValues.indexOf(properties[STEP_DIM.holdTime].value);
        dataChart[5] = {
            x: dataChart[4].x + (holdTimeIndex > 0 ? (holdTimeIndex * 11) : 0),
            y: +properties[STEP_DIM.stepDimLevel].value,
            timeLabel: "holdTime-3",
            section: 4
        }

        const endfadeTimeIndex = properties[STEP_DIM.endfadeTime].valueMeta.availableValues.indexOf(properties[STEP_DIM.endfadeTime].value);
        dataChart[6] = {
            x: dataChart[5].x + (endfadeTimeIndex > 0 ? (endfadeTimeIndex * 12) : 0),
            y: +properties[STEP_DIM.nominalLevel].value,
            timeLabel: "endfadeTime-4",
            section: 5
        }

        dataChart[7] = {
            x: dataChart[6].x + 70,
            y: +properties[STEP_DIM.nominalLevel].value,
            timeLabel: "endTime-0",
            section: 6
        }

        dataChart[8] = {
            x: dataChart[7].x,
            y: 0,
            section: 6
        }

        return dataChart;
    }

    getXLabels(dataChart) {

        const labels = [];
        const smallLabels = [];
        const ticks = [];

        dataChart.forEach((el, index) => {
            switch (el.timeLabel) {
                case 'startTime-0':
                    ticks.push(el.x);
                    labels.push({ label: 'On', x: el.x });
                    break;
                case 'switchOnFadeTime-1':
                    ticks.push(el.x);
                    smallLabels.push({ label: '1', x: (el.x + dataChart[index - 1].x) / 2 });
                    break;
                case 'dimStart-0':
                    ticks.push(el.x);
                    labels.push({ label: 'Dim Start', x: el.x });
                    break;
                case 'startfadeTime-2':
                    ticks.push(el.x);
                    smallLabels.push({ label: '2', x: (el.x + dataChart[index - 1].x) / 2 });
                    break;
                case 'dimEnd-0':
                    ticks.push(el.x);
                    labels.push({ label: 'Dim End', x: el.x });
                    break;
                case 'holdTime-3':
                    ticks.push(el.x);
                    smallLabels.push({ label: '3', x: (el.x + dataChart[index - 1].x) / 2 });
                    break;
                case 'endfadeTime-4':
                    ticks.push(el.x);
                    smallLabels.push({ label: '4', x: (el.x + dataChart[index - 1].x) / 2 });
                    break;
                case 'endTime-0':
                    ticks.push(el.x);
                    labels.push({ label: 'Off', x: el.x });
                    break;
                default:
                    break;
            }
        });

        return { labels: labels, smallLabels: smallLabels, ticks: ticks };
    }

    getYLabels(dataChart) {
        const labels = {};

        //insert zero label
        const zero = 0;
        labels[zero] = { label: '0', y: zero };

        //insert data labels
        dataChart.forEach((el) => {
            const val = Math.round(el.y);
            if (!labels[val]) {
                labels[val] = { label: val.toString(), y: val }
            }
        });

        //insert max label if max value is not present
        const max = this.props.properties[STEP_DIM.nominalLevel].value;
        if (!labels[max]) {
            labels[max] = { label: 'max', y: max };
        }

        //insert min label if min value is not present
        const min = this.props.properties[STEP_DIM.nominalLevel].value;
        if (!labels[min]) {
            labels[min] = { label: 'min', y: min };
        }

        return Object.keys(labels).map((key) => { return labels[key]; });
    }

    getDataChartSD(properties) {

        let dataChartSD = [{}, {}, {}, {}];

        let cont = 100;

        const switchOnFadeTimeIndex = properties[STEP_DIM.switchOnFadeTime].valueMeta.availableValues.indexOf(properties[STEP_DIM.switchOnFadeTime].value);
        cont += (switchOnFadeTimeIndex > 0 ? (switchOnFadeTimeIndex * 11) : 0);

        cont += 70;

        dataChartSD[0].x = cont + 0;
        dataChartSD[0].y = 0;

        dataChartSD[1].x = cont + 0;
        dataChartSD[1].y = 50;

        const startfadeTimeIndex = properties[STEP_DIM.startfadeTime].valueMeta.availableValues.indexOf(properties[STEP_DIM.startfadeTime].value);
        cont += (startfadeTimeIndex > 0 ? (startfadeTimeIndex * 12) : 0);

        cont += 70;

        dataChartSD[2].x = cont + 0;
        dataChartSD[2].y = 50;

        dataChartSD[3].x = cont + 0;
        dataChartSD[3].y = 0;

        return dataChartSD;
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        validationSummary: state.project.validationSummary,
        issues: state.project.issueByProperty,
    };
};

const mapDispatchToProps = {
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StepDim);
